import { largeBulkPickupData } from "constants-lib/seo/largeBulkPickupData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getBulkTrashPickup = () => {
  const data = largeBulkPickupData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addBulkTrashPickup = () => {
  if (
    window.location.href.includes(`/us/en/home/bulk-trash-pickup`) &&
    document.getElementById(`bulkTrashPickup`) === null
  ) {
    const script = bulkTrashPickupJSONLD()
    addJSONLDToHead(script, `bulkTrashPickup`)
  } else {
    removeElement(`bulkTrashPickup`)
  }
}

// JSON LD template for FAQ Bagster
const bulkTrashPickupJSONLD = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getBulkTrashPickup(),
  }
  return FaqBagsterTemplate
}
